module.exports = __webpack_public_path__ + "img/E281.ac0840d8.svg";